import {
  ToastContainer as LibToastContainer,
  toast as libToast,
  ToastOptions,
} from 'react-toastify';
import { createGlobalStyle } from 'styled-components';

// Reference: https://animista.net/play/basic/slide/slide-right
const GlobalToastStyle = createGlobalStyle`
  :root {
    --toastify-color-success: ${({ theme }) => theme.colors.green80};
    --toastify-color-error: ${({ theme }) => theme.colors.red80};
    --toastify-icon-color-success: ${({ theme }) => theme.colors.grayWhite};
    --toastify-icon-color-error: ${({ theme }) => theme.colors.grayWhite};
    --toastify-toast-min-height: 48px;
  }

  .ds__toast-container.Toastify__toast-container {
    
  }

  .ds__toast.Toastify__toast {
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
    .Toastify__toast-body {
      ${({ theme }) => theme.typescales.body2};
      padding: 0;
      white-space: pre-wrap;
    }

    &.Toastify__toast--success {
      background: ${({ theme }) => theme.colors.green80};
      color: ${({ theme }) => theme.colors.grayWhite};
    }
    &.Toastify__toast--warning {
      background: ${({ theme }) => theme.colors.orange50};
      color: ${({ theme }) => theme.colors.grayWhite};
    }
    &.Toastify__toast--error {
      background: ${({ theme }) => theme.colors.red80};
      color: ${({ theme }) => theme.colors.grayWhite};
    }
  }
`;

// 동시에 화면에 표시할 수 있는 최대 토스트 개수
const MAX_TOASTS = 2;

export const ToastContainer = () => {
  return (
    <>
      <GlobalToastStyle />
      <LibToastContainer
        className={'ds__toast-container'}
        toastClassName={'ds__toast'}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        closeButton={false}
        icon={false}
        limit={0}
      />
    </>
  );
};

export type Options = Pick<ToastOptions, 'toastId' | 'autoClose' | 'onClose'>;

// 중복 토스트 큐잉 방지를 위한 활성 토스트 ID 추적
const activeToastIds = new Set<string | number>();

const showToast = (
  type: 'success' | 'warning' | 'error',
  message: string,
  options?: Options,
) => {
  const id = options?.toastId || `${type}_${message}`;

  // 이미 표시 중인 토스트는 중복 노출하지 않음
  if (activeToastIds.has(id)) {
    return;
  }

  // 화면에 표시 가능한 최대 개수 초과 시 새 토스트를 무시하여 순차 큐잉 방지
  if (activeToastIds.size >= MAX_TOASTS) {
    return;
  }

  activeToastIds.add(id);

  libToast[type](message, {
    ...options,
    toastId: id,
    onClose: (props) => {
      activeToastIds.delete(id);
      options?.onClose?.(props);
    },
  });
};

export const toast = {
  success: (message: string, options?: Options) => showToast('success', message, options),
  warning: (message: string, options?: Options) => showToast('warning', message, options),
  error: (message: string, options?: Options) => showToast('error', message, options),
} as const;
